import React from 'react';
import { Chip, Button, Stack } from '@mui/material';
import {
  Check as CheckIcon,
  X as CloseIcon,
  AlertTriangle,
} from 'react-feather';
import includes from 'lodash/includes';

export const ProposalPaymentsChip = ({ venue }) => {
  if (venue?.paymentsEnabled) {
    return <GreenChip label="Proposal Payments Visible" />;
  }
  return <RedChip label="Proposal Payments Hidden" />;
};

export const GreenChip = (props) => {
  return (
    <Chip color="success" icon={<CheckIcon />} variant="contained" {...props} />
  );
};

export const RedChip = (props) => {
  return (
    <Chip color="error" icon={<CloseIcon />} variant="contained" {...props} />
  );
};

export const StripeChip = ({ venue }) => {
  const label = 'Stripe Connected';
  if (venue.stripeAccount) {
    return <GreenChip label={label} />;
  }
  return <RedChip label={label} />;
};

export const SquareChip = ({ venue }) => {
  const label = 'Square Connected';
  if (venue.squareAccount) {
    return <GreenChip label={label} />;
  }
  return <RedChip label={label} />;
};

export const LegacyChip = ({ subscription }) => {
  const planName = subscription?.planName;
  const isLegacy = includes(['Legacy Plan', 'Legacy Price'], planName);
  if (!isLegacy) {
    return null;
  }
  return (
    <>
      <Button
        href={`https://dashboard.stripe.com/subscriptions/${subscription?.stripeSubscriptionId}`}
        target="_blank"
        rel="noreferrer"
        variant="contained"
        color="warning"
        startIcon={<AlertTriangle />}
      >{`On ${planName}`}</Button>
    </>
  );
};
